import { Modal } from 'antd';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/UserGroup/UserGroupModel';
import { RootState } from '../../../store';
import UserGroupForm from '../UserGroupForm/UserGroupForm';

const UserGroupModal: FC<any> = () => {
  const dispatch = useDispatch();
  const reduxUserGroup = useSelector((state: RootState) => state.models.userGroup);

  return (
    <Modal
      title={!!reduxUserGroup.id ? 'Modifica' : 'Adauga'}
      open={reduxUserGroup.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <UserGroupForm />
    </Modal>
  );
};

export default UserGroupModal;
